import { setSavedFiltersName } from "@js/apps/common/components/save-filters/slice";
import type { FilterLocation } from "@js/apps/filters/types";

export const savedFilterLoaded = ({
  location,
  name,
}: {
  location: FilterLocation;
  name: string | null;
}) => {
  return setSavedFiltersName({ location, name });
};
